import { $api, $file } from "../api"
import { MedCardStatuses } from "../pages/Meds/types"




export const createFileRequest = async (file: any, api_url?: string) => {
    return await $api.post(`${api_url || ''}/v1/files`, file)
}

export const getBase64FileRequest = (name: string) => {

    return $api.get(`/v1/files/${name}/base64`)
}

export const createFileFromBase64 = (data: string) => {

    return $api.post(`/v1/files/base64`, { data: data })
}

export const getBufferFileRequest = (name: string) => {
  
    return $api.get(`/v1/files/${name}/buffer`)
}

export const createTitle = async (payload: any, api_url?: string) => {
  return await $api.post(`${api_url || ''}/v1/kontur/titles`, payload)
}

export interface excelArgs {
    to?: string,
    from?: string,
    status?: MedCardStatuses,
    id?: number,
    per_page?: number,
    page?: number,
}
export const getExcelReportTableRequest = (api_url: string, query: any) => {
    return $api.post(`${api_url}/v1/cards/excel` + `?query=${JSON.stringify(query)}`)
}

export const getVideoBlobSrc = async (url: string) => {
    return await fetch(url, { mode: 'cors', headers: {'Access-Control-Allow-Origin':'*'}}).then(r => r.blob().then((blob) => URL.createObjectURL(blob)))
}